import { CartFormData } from './types/formTypes';

/**
 * Extracts form data from the add-to-cart button's form.
 * @param submitButton - The submit button that triggered the event.
 * @returns The extracted form data or null if extraction fails.
 */
export function extractFormData(submitButton: HTMLButtonElement): CartFormData | null {
    const form = submitButton.closest('form');

    if (!form) {
        console.error('The submit button does not belong to any form.');
        return null;
    }

    const variantIdInput = form.querySelector<HTMLInputElement>('input[name="id"]');
    if (!variantIdInput || !variantIdInput.value) {
        console.error('The form does not contain a valid "id" input.');
        return null;
    }

    let quantity = 1;
    const quantityInput = form.querySelector<HTMLInputElement>('input[name="quantity"]');
    if (quantityInput && quantityInput.value) {
        quantity = parseInt(quantityInput.value, 10);
    }

    const propertyStyle = form.querySelector<HTMLInputElement>('input[name="properties[Style]"]');

    const formData: CartFormData = {
        items: [{
            id: parseInt(variantIdInput.value, 10),
            quantity: quantity,
            properties: {
                'Style': propertyStyle?.value
            }
        }],
        sections: 'ajax-side-cart,ajax-cart-icon' // Extracted constant moved here
    };

    return formData;
}

/**
 * Parses a string of HTML into an HTML element.
 * @param section - The HTML string to parse.
 * @returns The parsed HTML element.
 */
export function parseHTMLSection(section: string): HTMLElement {
    const parser = new DOMParser();
    const doc = parser.parseFromString(section, 'text/html');
    return doc.body.firstChild as HTMLElement;
}